export default {
  background: {
    toNight: 'Cambiar a modo nocturno',
    toDay: 'Cambiar a modo diurno'
  },
  colorPicker: 'Seleccionar color de fondo',
  zoom: {
    in: 'Acercar',
    out: 'Alejar'
  },
  layers: 'Gestionar capas',
  legend: {
    show: 'Mostrar leyenda',
    hide: 'Ocultar leyenda'
  },
  coordinates: 'Ver coordenadas',
  mapControls: {
    show: 'Mostrar controles del mapa',
    hide: 'Ocultar controles del mapa'
  },
  download: 'Descargar captura del mapa'
}
